import { createSlice } from "@reduxjs/toolkit";

const countrySlice = createSlice({
  name: "country",
  initialState: {
    countryList: [], // Store API response here
  },
  reducers: {
    setcountry(state, action) {
      state.countryList = action.payload; // Update state correctly
    },
  },
});

export const { setcountry } = countrySlice.actions;
export default countrySlice.reducer;
